function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import PropTypes from "prop-types";
import React, { Component } from "react";
import classnames from "classnames";
import Base from "../Base/Base";
import "./Grid.css";
/**
 * Grid provides an abstraction over CSS Flex box with Grid acting as the Flex parent and
 * GridCell the Flex child. It also adds the option for gutters between flex children.
 * By default Grid is responsive, altering Grid Cells to take up full rows as the screen-width reduces.
 */

export default class Grid extends Component {
  render() {
    const {
      children,
      className,
      direction,
      fill,
      fit,
      full,
      gutters,
      horizontalAlign,
      horizontalGutters = gutters,
      none,
      responsive,
      shrink,
      verticalAlign,
      verticalGutters = gutters,
      wrap,
      ...rest
    } = this.props;
    const classes = classnames("ax-grid", {
      "ax-grid--responsive": responsive,
      "ax-grid--columns": direction === "column",
      [`ax-grid--gutters-horizontal--${horizontalGutters}`]: typeof horizontalGutters === "string",
      [`ax-grid--gutters-vertical--${verticalGutters}`]: typeof verticalGutters === "string",
      "ax-grid--fill": fill === true,
      [`ax-grid--fill--${fill}`]: fill && fill !== true,
      "ax-grid--fit": fit === true,
      [`ax-grid--fit--${fit}`]: fit && fit !== true,
      "ax-grid--full": full === true,
      [`ax-grid--full--${full}`]: full && full !== true,
      "ax-grid--none": none === true,
      [`ax-grid--none--${none}`]: none && none !== true,
      "ax-grid--shrink": shrink === true,
      [`ax-grid--shrink--${shrink}`]: shrink && shrink !== true,
      [`ax-grid--vertical-${verticalAlign}`]: verticalAlign,
      [`ax-grid--horizontal-${horizontalAlign}`]: horizontalAlign,
      "ax-grid--wrap": wrap === true
    }, className);
    return /*#__PURE__*/React.createElement(Base, _extends({
      space: "x6"
    }, rest, {
      className: "ax-grid__container"
    }), /*#__PURE__*/React.createElement("div", {
      className: classes
    }, children));
  }

}

_defineProperty(Grid, "defaultProps", {
  direction: "row",
  responsive: true,
  gutters: "medium",
  wrap: true
});